export const UNAUTHORIZED_ERROR = 'UNAUTHORIZED_ERROR'
export const SERVER_SIDE_ERROR = 'SERVER_SIDE_ERROR'
export const NETWORK_ERROR = 'NETWORK_ERROR'
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR'
export const MAINTENACE_ERROR = 'MAINTENACE_ERROR'
